export const headerSysAdmin = () => {
  return {
    Authorization: "Bearer " + localStorage.getItem("token"),
    "Content-Type": "application/json",
    "sec-fetch-dest": "empty",
    "sec-fetch-mode": "cors",
    "sec-fetch-site": "same-origin",
  };
};

export const headerForUpload = () => {
  let headers = headerSysAdmin();
  delete headers['Content-Type'];
  return headers;
}
